import { PartialBrief } from '../../../Types/Brief'

const isBriefUsingGuestSession = ({ guest, userId }: PartialBrief): boolean =>
  !!guest && !!userId && !!guest.authenticated && !guest.newlyRegistered

export default isBriefUsingGuestSession
